import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { legacyBag } from '../../../legacy-leaf';

import {
    columnDataSchemaLegacy,
    columnDeviceDataSchemaLegacy,
    columnDeviceStylesSchemaLegacy,
    columnStylesSchemaLegacy,
} from './data';

/**
 * Column envelope. Unlike sections there is no `type` discriminator: the header
 * (`specific`) columns share this exact shape and differ only in their seeded
 * values, so one schema covers both.
 *
 * `widgets` holds widget ids in the store and whole widgets — plus grids and
 * tabs — while the structure adapter still has the denormalized tree, hence
 * `unknown[]`.
 */
export const columnLegacyV0Schema = z.object({
    id: z.string(),
    sectionId: z.string(),
    widgets: z.array(z.unknown()),

    data: legacyBag(columnDataSchemaLegacy),
    styles: legacyBag(columnStylesSchemaLegacy),

    mobileData: legacyBag(columnDeviceDataSchemaLegacy),
    mobileStyles: legacyBag(columnDeviceStylesSchemaLegacy),
    tabletData: legacyBag(columnDeviceDataSchemaLegacy),
    tabletStyles: legacyBag(columnDeviceStylesSchemaLegacy),
});

export type LegacyColumn = z.infer<typeof columnLegacyV0Schema>;

/**
 * Legacy-only entity: the persisted column shape is the only version so far (no
 * v0 redesign yet). Single 'web' variant today.
 */
export const LegacyColumnEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: columnLegacyV0Schema }]);
